import context from '@/context'

export const initialState = {
  fetching: false,
  granted: [],
  institutionPermissions: {}
}

export const actionTypes = {
  setPermissions: 'permissions/setPermissions',
  fetching: 'permissions/fetching'
}

export const getPermissions = (institutionIds, isChangeItem) => async (dispatch, getState) => {
  const state = getState()

  if (state.permissions.fetching) return
  dispatch({ type: actionTypes.fetching })

  if (!institutionIds || institutionIds.length === 0) institutionIds = [-1]

  const perms = await context.api.permissionService.getPermissionsForInstitutionIds({ InstitutionIds: institutionIds })
  dispatch({ type: actionTypes.setPermissions, permissions: state.permissions.granted, institutionPermissions: perms })
}

export const setPermissions = (permissions, institutionPermissions) => {
  const parsed = JSON.parse(institutionPermissions)

  const sanitizedInstitutionPermissions = Object.entries(parsed).reduce((acc, [key, value]) => {
    const { InstitutionEdit, InstitutionReadOnly, IndividualEdit, IndividualReadOnly } = value
    const modifiedValue = {
      institutionEdit: InstitutionEdit,
      institutionReadOnly: InstitutionReadOnly,
      individualEdit: IndividualEdit,
      individualReadOnly: IndividualReadOnly
    }

    return { ...acc, [key]: modifiedValue }
  }, {})

  return { type: actionTypes.setPermissions, permissions, institutionPermissions: sanitizedInstitutionPermissions }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.setPermissions: return {
      ...state,
      fetching: false,
      granted: action.permissions || [],
      institutionPermissions: Object.keys(action.institutionPermissions).length !== 0 ? action.institutionPermissions : state.institutionPermissions
    }
    case actionTypes.fetching: return { ...state, fetching: true }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/Permissions.js